import { useRouter } from 'next/router';
import type { HalfHalfImages } from '../../../../../types/MiniSiteContents';
import ContentWrapper from '../../../common/ContentWrapper';
import ImageWithFallback from '../../../common/ImageWithFallback';
import isAbsoluteUrl from '../../../../core/helpers/isAbsoluteUrl';
import Markdown from '../../../common/Markdown/Markdown';

type Props = {
  miniSiteContent: HalfHalfImages;
};

const MiniSiteHalfHalfImages = ({ miniSiteContent }: Props) => {
  const router = useRouter();

  const { contentTitle, contentLeft, contentRight } = miniSiteContent;

  return (
    <ContentWrapper className="w-full">
      {contentTitle && <p className="pb-6 text-title3 font-bold">{contentTitle}</p>}
      <div className="flex w-full flex-col gap-8 md:flex-row">
        <div className="relative min-h-[288px] w-full rounded-lg">
          <ImageWithFallback
            alt="half-half-image-left"
            className="relative rounded-xl"
            src={contentLeft.photoUrl || '/fallback-img-3704x2304.png'}
            layout="fill"
            objectFit="cover"
            sizes="(max-width: 768px) 100vw, 50vw"
            fallbackSrc="/fallback-img-3704x2304.png"
            url={
              contentLeft.link &&
              (isAbsoluteUrl(contentLeft.link)
                ? contentLeft.link
                : router.asPath + contentLeft.link)
            }
            target={isAbsoluteUrl(contentLeft.link) ? '_blank' : '_self'}
          >
            <>
              <div className="absolute bottom-0 size-full rounded-xl bg-gradient-to-t from-black" />
              <div className="relative bottom-0 flex size-full flex-col justify-between p-6 text-white">
                <p className="w-full text-right text-title3 font-bold">{contentLeft.title}</p>
                <div className="flex flex-col gap-2">
                  <p className="font-bold">{contentLeft.subTitle}</p>
                  <Markdown className="text-small">{contentLeft.description || ''}</Markdown>
                </div>
              </div>
            </>
          </ImageWithFallback>
        </div>
        <div className="relative min-h-[288px] w-full rounded-lg">
          <ImageWithFallback
            alt="half-half-image-right"
            className="relative rounded-xl"
            src={contentRight.photoUrl || '/fallback-img-3704x2304.png'}
            layout="fill"
            objectFit="cover"
            sizes="(max-width: 768px) 100vw, 50vw"
            fallbackSrc="/fallback-img-3704x2304.png"
            url={
              contentRight.link &&
              (isAbsoluteUrl(contentRight.link)
                ? contentRight.link
                : router.asPath + contentRight.link)
            }
            target={isAbsoluteUrl(contentRight.link) ? '_blank' : '_self'}
          >
            <>
              <div className="absolute bottom-0 size-full rounded-xl bg-gradient-to-t from-black" />
              <div className="relative bottom-0 flex size-full flex-col justify-between p-6 text-white">
                <p className="w-full text-right text-title3 font-bold">{contentRight.title}</p>
                <div className="flex flex-col gap-2">
                  <p className="font-bold">{contentRight.subTitle}</p>
                  <Markdown className="text-small">{contentRight.description || ''}</Markdown>
                </div>
              </div>
            </>
          </ImageWithFallback>
        </div>
      </div>
    </ContentWrapper>
  );
};

export default MiniSiteHalfHalfImages;
